import React from 'react'
import { storiesOf } from '@storybook/react'

import GameCardHeader from 'components/GameCard/components/GameCardHeader'

storiesOf('GameCard/GameCardHeader', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#DDD' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#DDD', width: 320, borderTop: '1px solid white' }}>{story()}</div>
    </>
  ))
  .add('only with teams', () => (
    <GameCardHeader
      homeTeam="Wolverhampton Wanderers"
      awayTeam="Manchester United"
      separator="1 : 0"
    />
  ))
  .add('teams with avatar', () => (
    <GameCardHeader
      homeTeam="Wolverhampton Wanderers"
      awayTeam="Manchester United"
      separator="1 : 0"
      avatar={{
        url: 'https://randomuser.me/api/portraits/thumb/men/79.jpg',
        value: 812,
      }}
    />
  ))
  .add('with quiz mode button', () => (
    <GameCardHeader
      homeTeam="Wolverhampton Wanderers"
      awayTeam="Manchester United"
      separator="1 : 0"
      displayQuizButton
    />
  ))
  .add('classic game', () => (
    <GameCardHeader
      isClassicGame
      separator="-"
      homeTeam="Bundesliga"
      awayTeam="Matchday 23"
    />
  ))
